module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Einstellungen ro.24bd1d19.svg";